import React from 'react'
import { DividerHorizontal } from '../../shared/DividerHorizontal'

import AddCountryCodeCountry from './stages/AddCountryCodeCountry'
import AddCountryCodeDate from './stages/AddCountryCodeDate'
import { PlaceEntryType } from '@/app/constants/placeEntryType'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddCountryCodeForm = ({ data, setData, companyId }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-p-6">
      <fieldset className="tw-flex tw-flex-wrap tw-gap-4">
        {[PlaceEntryType.BEGIN, PlaceEntryType.END].map((entryType) => (
          <label key={entryType} className="tw-flex tw-items-center tw-gap-2">
            <input
              type="radio"
              name="countryCode-entryType"
              value={entryType}
              checked={data.entryType === entryType}
              onChange={() => setData({ ...data, entryType })}
            />
            {t(
              entryType === PlaceEntryType.BEGIN
                ? 'countryCode.begin'
                : 'countryCode.end',
            )}
          </label>
        ))}
      </fieldset>
      <DividerHorizontal />
      <AddCountryCodeCountry
        companyId={companyId}
        data={data}
        setData={setData}
      />
      <DividerHorizontal />
      <AddCountryCodeDate data={data} setData={setData} />
    </div>
  )
}

export default AddCountryCodeForm
